import { useFormik } from 'formik';
import { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { isNotEmpty, KTSVG } from '../../../../_metronic/helpers';
import Swal from 'sweetalert2'
import * as Yup from 'yup';
import { dispatchDwonload, getDispatchStatus, getFilterOption } from '../api';
import { downloadCsv } from '../../../component/helper';
const editUserSchema = Yup.object({
  // dispatch_mode: Yup.string().required('Dispatch Mode is required'),
  // status: Yup.string().required('Status is required'),
  // sub_status: Yup.string().when('status', {
  //   is: (status) => !!status,
  //   then: Yup.string().required('Sub Status is required'),
  // }),
});
/**
 * DownloadDispatch
 * Component for handling dispatch download logic and rendering download modal.
 */
export const DownloadDispatch = () => {
  const styles = {
    borderRadius: '0.475rem',
    boxShadow: '0 0 50px 0 rgb(82 63 105 / 15%)',
    backgroundColor: '#fff',
    color: '#7e8299',
    fontWeight: '500',
    margin: '0',
    width: 'auto',
    padding: '1rem 2rem',
    top: 'calc(50% - 2rem)',
    left: 'calc(50% - 4rem)',
  }
  const [loader, setloader] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [subStatusOptions, setStatus] = useState([])
  const [filterOption, setFilterOption] = useState([]);
  const formik = useFormik({
    initialValues: {
      dispatch_mode: '',
      status: '',
      sub_status: '',
      select_project: ""
    },

    validationSchema: editUserSchema,
    onSubmit: async (values, { setSubmitting }) => {

      try {
        setSubmitting(true);
        const confirmResult = await Swal.fire({
          title: 'Are you sure?',
          text: 'Are you sure you want to download?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          reverseButtons: true,
          customClass: {
            confirmButton: 'btn btn-danger',
            cancelButton: 'btn btn-secondary'
          }
        });
        if (confirmResult.isConfirmed) {
          setloader(true)
          if (isNotEmpty(values)) {
            const query = `filter_project=${values?.select_project}&filter_status=${values?.status}&filter_dispatch_mode=${values?.dispatch_mode}&filter_substatus=${values?.sub_status}`
            const response = await dispatchDwonload(query);
            /**
             * getFileName
             * Returns a formatted file name string based on input value.
             * @param value - string to format
             * @returns formatted string
             */
            const getFileName = (value) => {
              const updatedValue = '_' + (value.split('- ')[0]).trim();
              return updatedValue.replace(/ /g, '_');
            }

            let fileName = "Download";
            if (values?.project) {
              fileName = fileName + getFileName(values?.project)
            }
            if (values?.mode) {
              fileName = fileName + getFileName(values?.mode)
            }
            if (values?.status_name) {
              fileName = fileName + getFileName(values?.status_name)
            }

            downloadCsv({
              data: response,
              fileName: fileName,
              fileType: 'text/csv'
            })
            setloader(false)
            setIsModalOpen(false)

          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setSubmitting(false);
      }
    }
  })


  /**
   * confirmationPopup
   * Opens the confirmation modal for download.
   * @param type - modal type
   */
  const confirmationPopup = (type) => {
    setIsModalOpen(type)
  }

  /**
   * handleReset
   * Resets the form and closes the modal.
   */
  const handleReset = () => {
    formik.resetForm()
    setIsModalOpen(false);

  }
  useEffect(() => {
    getDispatchStatus('dispatch').then((d) => { setStatus(d?.data) })
    getFilterOption('dispatch').then((d) => setFilterOption(d.data));
  }, [])
  useEffect(() => {

  }, [filterOption])

  return (<>
    <div
      onClick={() => confirmationPopup(true)}
      className="btn btn-light-dark me-3"
    >
      <i className="bi bi-download  fs-4"></i> Download
    </div>
    <Modal className={'modal-lg'} show={isModalOpen} onHide={() => setIsModalOpen(false)}>
      <Modal.Header className='h-20px' closeButton>  <h4 className="fw-semibold fs-5 py-1">Dispatch Download  </h4></Modal.Header>
      <Modal.Body>
        {loader && <div style={{ ...styles, position: 'absolute', textAlign: 'center' }}>
          <button class="btn btn-primary" type="button" disabled>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span> Loading...
          </button>
        </div>}
        <div className='px-2'>
          <form id="kt_ecommerce_add_FAQ_form" className="form fv-plugins-bootstrap5 fv-plugins-framework" onSubmit={formik.handleSubmit} noValidate>
            <div className="card-body">
              <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed p-6 mb-10">
                <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-3x svg-icon-warning me-5' />

                <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                  <div className="mb-3 mb-md-0 fw-semibold">
                    <h5 className="text-gray-900 fw-semibold">We need your attention!</h5>
                    <div className="fs-7 text-gray-700 pe-7">
                      To proceed with the download, please make a selection based on your preference:
                      <ul>
                        <li>If you want to download based on the project, select the project.</li>
                        <li>If you want to download based on the status, select the status.</li>
                        <li>If you want to download based on the dispatch stage, select the dispatch stage.</li>
                      </ul>
                      <strong>Note:</strong> Selecting the dispatch mode is mandatory for all options.
                    </div>


                  </div>

                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 col-xl-12">
                  <div className="row">
                    <label className="col-lg-3 col-form-label  fw-semibold fs-6">Select Project </label>
                    <div className="col-lg-9 fv-row fv-plugins-icon-container">
                      <select
                        {...formik.getFieldProps('select_project')}
                        className="form-select form-select-solid rounded-0 form-select-md"
                        aria-label="Select Dispatch Mode"
                        onChange={(e) => {
                          formik.setFieldValue('select_project', e.target.value)
                          formik.setFieldValue('project', e.target.selectedOptions[0].text)

                        }}

                      >
                        <option value="">Select Project</option>
                        {filterOption?.project?.map((item) => (
                          <option key={item?.id} value={item?.id}>{item?.project_name} - ({item?.order_count})</option>

                        ))}
                      </select>
                      {formik.touched.select_project && formik.errors.select_project ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            <span className="text-danger" role="alert">{formik.errors.select_project}</span>
                          </div>
                        </div>
                      ) : (
                        <div className="text-muted fs-7"></div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 col-xl-12 pt-4">
                  <div className="row">
                    <label className="col-lg-3 col-form-label  fw-semibold fs-6">Dispatch Mode</label>
                    <div className="col-lg-9 fv-row fv-plugins-icon-container">
                      <select
                        {...formik.getFieldProps('dispatch_mode')}
                        className="form-select form-select-solid rounded-0 form-select-md"
                        aria-label="Select Dispatch Mode"
                        onChange={(e) => {
                          formik.setFieldValue('dispatch_mode', e.target.value)
                          formik.setFieldValue('mode', e.target.selectedOptions[0].text)

                        }}
                      >
                        <option value="">Select Dispatch Mode</option>
                        {subStatusOptions?.mode?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name} - ({item?.order_count})
                          </option>
                        ))}
                      </select>
                      {formik.touched.dispatch_mode && formik.errors.dispatch_mode ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            <span className="text-danger" role="alert">{formik.errors.dispatch_mode}</span>
                          </div>
                        </div>
                      ) : (
                        <div className="text-muted fs-7"></div>
                      )}
                    </div>
                  </div>
                </div>


                <div className="col-lg-12 col-xl-12 pt-4">
                  <div className="row">
                    <label className="col-lg-3 col-form-label  fw-semibold fs-6">Dispatch Status</label>
                    <div className="col-lg-9 fv-row fv-plugins-icon-container">
                      <select
                        {...formik.getFieldProps('status')}
                        className="form-select form-select-solid rounded-0 form-select-md"
                        aria-label="Select Status"
                        onChange={(e) => {
                          formik.setFieldValue('status', e.target.value)
                          formik.setFieldValue('status_name', e.target.selectedOptions[0].text)
                        }}
                      >
                        <option value="">Select Status</option>
                        {formik.values.dispatch_mode &&
                          Object.keys(subStatusOptions?.status?.[formik.values.dispatch_mode] || {}).map((status) => (
                            <option key={status} value={status}>
                              {status}
                            </option>
                          ))}
                      </select>
                      {formik.touched.status && formik.errors.status ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            <span className="text-danger" role="alert">{formik.errors.status}</span>
                          </div>
                        </div>
                      ) : (
                        <div className="text-muted fs-7"></div>
                      )}
                    </div>
                  </div>
                </div>


                <div className="col-lg-12 col-xl-12 pt-4">
                  <div className="row">
                    <label className="col-lg-3 col-form-label  fw-semibold fs-6">Dispatch Stage</label>
                    <div className="col-lg-9 fv-row fv-plugins-icon-container">
                      <select
                        {...formik.getFieldProps('sub_status')}
                        className="form-select form-select-solid rounded-0 form-select-md"
                        aria-label="Select Dispatch Stage"
                      >
                        <option value="">Select Stage</option>
                        {formik.values.dispatch_mode &&
                          formik.values.status &&
                          (subStatusOptions?.status?.[formik.values.dispatch_mode]?.[formik.values.status] || []).map((subStatus, index) => (
                            <option key={index} value={subStatus?.id}>
                              {subStatus?.status}
                            </option>
                          ))}
                      </select>
                      {formik.touched.sub_status && formik.errors.sub_status ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            <span className="text-danger" role="alert">{formik.errors.sub_status}</span>
                          </div>
                        </div>
                      ) : (
                        <div className="text-muted fs-7"></div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

            </div>


            <div className='card-footer pt-4'>
              <div className="d-flex justify-content-end gap-3">
                <button type="button" className="btn btn-light btn-active-light-primary fw-semibold me-2 px-6" onClick={() => handleReset()}>
                  <span className="indicator-label">Reset </span>
                  {(formik.isSubmitting) && <span className="indicator-progress">Please wait...
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>}
                </button>
                <button type="submit" className="btn btn-primary  bg-hover-success" >
                  <span className="indicator-label">Download </span>
                  {(formik.isSubmitting) && <span className="indicator-progress">Please wait...
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>}
                </button>
              </div>
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  </>
  )
}